<template>
  <div class="photo-wall-item">
    <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
      <el-form-item :label="$t('microSite.common.form.img')" prop='image'>
        <ImageUpload v-model="form.image.src" :otherTips="uploadTip"></ImageUpload>
      </el-form-item>
      <el-form-item v-if="showDetailLinkFormLine" :label="$t('microSite.common.form.clickToJump')" prop='detailLink'>
        <SwitchButton v-model="form.detailLink.isActive" :options="detailLinkOptions"></SwitchButton>
        <template v-if="form.detailLink.isActive" >
          <image-link :link="form.detailLink"></image-link>
        </template>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../../editorTemplate'
import SwitchButton from '../../../components/editor/switchButton'
import ImageUpload from '../../../components/editor/imageUpload'
import ImageLink from '../../../components/link'
import { suggestionUploadSize } from '../index'

export default {
  components: {
    SwitchButton,
    ImageUpload,
    ImageLink
  },
  mixins: [editorTemplate],
  data () {
    const checkUpload = (rule, value, callback) => {
      if (!value.src) {
        return callback(new Error(this.$t('microSite.common.form.uploadCanNotEmpty')))
      }
      callback()
    }
    const checkLink = (rule, value, callback) => {
      if (value.isActive && !value.url) {
        return callback(this.$t('microSite.common.form.linkCanNotEmpty'))
      }
      callback()
    }
    return {
      form: {
        title: null,
        image: {
          src: null
        },
        detailLink: {
          isActive: false,
          isInnerPage: true,
          url: null,
          openNewWindow: false
        }
      },
      rules: {
        image: [
          { validator: checkUpload, trigger: 'blur' }
        ],
        detailLink: [
          { validator: checkLink, trigger: 'blur' }
        ]
      },
      detailLinkOptions: [
        {
          label: this.$t('microSite.common.form.no'),
          value: false
        },
        {
          label: this.$t('microSite.common.form.yes'),
          value: true
        }
      ],
      allInnerPages: []
    }
  },
  computed: {
    showDetailLinkFormLine () {
      return true
      // return this.renderData.parent.data.props.renderMode === renderMode.logo
    },
    uploadTip () {
      const renderMode = this.renderData.parent.data.props.renderMode
      const size = suggestionUploadSize[this.isMobile ? 'mobile' : 'pc'][renderMode]
      if (size) {
        return this.$t('microSite.component.upload.suggestion', { size: size })
      } else {
        return ''
      }
    }
  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.form.content = props.content
    this.form.image = {
      ...props.image
    }
    this.form.detailLink = {
      ...props.detailLink
    }
  },
  methods: {
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.image.src = this.form.image.src
      props.detailLink = { ...this.form.detailLink, url: this.form.detailLink.url && this.form.detailLink.url.trim() }

      this.updateConfigInRoot()
      return true
    }
  }
}
</script>

<style lang="scss" scoped>
.photo-wall-item {
  .link-container {
    margin-top: 10px;

    .link-type {
      width: 25%;
    }

    .link-path {
      width: 70%;
      margin-left: 5%;
    }
  }
}
</style>
